import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_LATLNG, LOCATIONS_ZOOM, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants";

export interface HazardCardConfig {
    key: string;
    title: string;
    value: string | number;
    subText: string;
    icon: string;        // Bootstrap / custom icon class
    iconBg: string;      // icon background color
}

export const NHIP_HIERARCHY: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']

export const NHIP_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        // 'India Boundary': {
        //     source: 'INDIA',
        //     displayName: 'India',
        //     name: 'India Boundary',
        //     visible: true,
        //     // hasLegend: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'odisha:india_boundary',
        //     layer_name: 'India Boundary',
        //     layeroptions_pane: 'base',
        //     // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
        //     group: 'boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.VECTOR_LAYER,
        //     type: LAYER_TYPES.VECTOR_LAYER,
        //     cql_filter_value: null,
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
        //     crs: 'EPSG4326',
        //     hasLables: true,
        //     applycql_filter: true,
        //     // legendName: 'FOG_LEGEND',
        //     layeroptions_protocol: 'WFS'
        // },
        'Country Boundaries': {
            source: 'INDIA',
            displayName: 'Country Boundaries',
            name: 'Country Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'odisha:india_boundary',
            layer_name: 'Country Boundaries',
            layeroptions_pane: 'state',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'State Boundary': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            // legendName: 'FOG_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'State Boundaries': {
            source: 'INDIA',
            displayName: 'State Boundaries',
            name: 'State Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
            layer_name: 'State Boundaries',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundaries': {
            source: 'INDIA',
            displayName: 'District Boundaries',
            name: 'District Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
            layer_name: 'District Boundaries',
            layeroptions_pane: 'max',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundary': {
            source: 'INDIA',
            displayName: 'District',
            name: 'District Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
            layer_name: 'District Boundary',
            layeroptions_pane: 'district',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'FOG_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'Block Boundary': {
            source: 'INDIA',
            displayName: 'Block',
            name: 'Block Boundary',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
            layer_name: 'Block Boundary',
            layeroptions_pane: 'state',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'FOG_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'State Boundary Labels': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES_UPDATED',
            crs: 'EPSG4326',
        },
        'District Boundary Labels': {
            source: 'INDIA',
            displayName: 'District Boundary Labels',
            name: 'District Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
            layer_name: 'District Boundary Labels',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'state_uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:ALL_INDIA_DISTRICT_NAMES_UPDATED',
            crs: 'EPSG4326',
        },
        'Block Boundary Labels': {
            source: 'INDIA',
            displayName: 'Block Boundary Labels',
            name: 'Block Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
            layer_name: 'Block Boundary Labels',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'dist_uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_LABELS_UPDATED',
            crs: 'EPSG4326',
        },
        'Fault Lines': {
            source: 'INDIA',
            displayName: 'Fault Lines',
            name: 'Fault Lines',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:EQ_FAULTLINE',
            layer_name: 'Fault Lines',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Hazard',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            crs: 'EPSG4326',
            legendName: 'Fault Lines',
            layeroptions_styles: 'Fault_Lines_Styles',
        },
        'Magnitude': {
            source: 'INDIA',
            displayName: 'Magnitude',
            name: 'Magnitude',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:EQ_POINTS',
            layer_name: 'Magnitude',
            layeroptions_pane: 'hazardPoints',
            group: 'Hazard',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.PIXI_LAYER,
            type: LAYER_TYPES.PIXI_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            legendName: 'Magnitude',
            time_filter_field: 'year',
            pixi_color: 'getEarthquakePointColor',
            pixi_popup: 'getEarthquakePointPopup',
            pixi_popup_pane: 'pixiPopup',
            pixi_radius: { 5: 3, 8: 3, 11: 5, 14: 7 },
            // pixi_border_color: '#4B4747',
            // pixi_border_width: 1,
            pixi_property_names: ['geom', 'mag', 'magtype', 'depth', 'place', 'time'],
        },
        // 'Cyclone Line': {
        //     source: 'INDIA',
        //     displayName: 'Cyclone Line',
        //     name: 'Cyclone Line',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:CYCLONE_LINES',
        //     layer_name: 'Cyclone Line',
        //     layeroptions_pane: 'marker',
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
        //     group: 'Hazard',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.WMS_LAYER,
        //     type: LAYER_TYPES.WMS_LAYER,
        //     cql_filter_value: null,
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     crs: 'EPSG4326',
        //     legendName: 'Cyclone Line',
        //     layeroptions_styles: 'Cyclone_Line_Style',
        //     applycql_filter: true,
        // },
        'Cyclone Line': {
            source: 'INDIA',
            displayName: 'Cyclone Line',
            name: 'Cyclone Line',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:CYCLONE_LINES',
            layer_name: 'Cyclone Line',
            layeroptions_pane: 'max',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Hazard',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'animateCycloneLines',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS',
            restrictFitBounds: true
        },
        'Cyclone Point': {
            source: 'INDIA',
            displayName: 'Cyclone Point',
            name: 'Cyclone Point',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:CYCLONE_POINTS',
            layer_name: 'Cyclone Point',
            layeroptions_pane: 'hazardPoints',
            group: 'Hazard',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.PIXI_LAYER,
            type: LAYER_TYPES.PIXI_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            legendName: 'Cyclone Point',
            time_filter_field: 'year',
            pixi_color: 'getCyclonePointColor',
            pixi_popup: 'getCyclonePointPopup',
            pixi_popup_pane: 'pixiPopup',
            pixi_radius: { 5: 3, 8: 4, 11: 6, 14: 8 },
            pixi_border_width: 0,
            pixi_property_names: ['geom', 'name', 'grade', 'obs_time', 'kt', 'ecp', 'basin'],
        },
        // 'Magnitude': {
        //     source: 'INDIA',
        //     displayName: 'Magnitude',
        //     name: 'Magnitude',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:EQ_POINTS',
        //     layer_name: 'Magnitude',
        //     layeroptions_pane: 'depth',
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
        //     group: 'Hazard',
        //     group_type: 'radio-deselect',
        //     // layerServiceType: LAYER_TYPES.WMS_LAYER,
        //     layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
        //     // type: LAYER_TYPES.WMS_LAYER,
        //     type: LAYER_TYPES.GEOJSON_LAYER,
        //     layeroptions_protocol: 'WFS',
        //     cql_filter_value: null,
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     crs: 'EPSG4326',
        //     layeroptions_styles: 'EQ_POINTS_Styles',
        //     legendName: 'Magnitude',
        //     pointToLayer: 'handleEarthquakePoints',
        //     restrictFitBounds: true
        // },
        'Zones': {
            source: 'INDIA',
            displayName: 'Zones',
            name: 'Zones',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:EQ_ZONE',
            layer_name: 'Zones',
            layeroptions_pane: 'state',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Hazard',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            crs: 'EPSG4326',
            layeroptions_protocol: 'WFS',
            legendName: 'Zones',
        },
        'Wind Zone': {
            source: 'INDIA',
            displayName: 'Wind Zone',
            name: 'Wind Zone',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:nhip_Wind_Zone',
            layeroptions_styles: 'HEATWAVE:wind_zone_colour',
            layer_name: 'nhip_Wind_zone',
            layeroptions_pane: 'village',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Hazard',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            crs: 'EPSG4326',
            legendName: 'Wind Zone',
        },
        //   'Cyclone Line': {
        //     source: 'INDIA',
        //     displayName: 'Cyclone Line',
        //     name: 'Cyclone Line',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:nhip_Line',
        //     layer_name: 'nhip_Line',
        //     layeroptions_pane: 'depth',
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
        //     group: 'Hazard',
        //     group_type: 'radio-deselect',
        //     // layerServiceType: LAYER_TYPES.WMS_LAYER,
        //     layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
        //     // type: LAYER_TYPES.WMS_LAYER,
        //     type: LAYER_TYPES.GEOJSON_LAYER,
        //     layeroptions_protocol: 'WFS',
        //     cql_filter_value: null,
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     crs: 'EPSG4326',
        //     filter: 'handleCycloneLines',
        //     layeroptions_styles:'nhip_dashed_line',
        //     legendName: 'Cyclone Line',
        //     restrictFitBounds: true,
        //     style: 'handleCycloneLineStyle',
        // },
        // 'Cyclone Point': {
        //     source: 'INDIA',
        //     displayName: 'Cyclone Point',
        //     name: 'Cyclone Point',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:CYCLONE_POINTS',
        //     layer_name: 'nhip_Points_Shape_File',
        //     // layeroptions_styles:'nhip_Points_Shape_color',
        //     layeroptions_pane: 'depth',
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
        //     group: 'Hazard',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
        //     type: LAYER_TYPES.GEOJSON_LAYER,
        //     cql_filter_value: null,
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     crs: 'EPSG4326',
        //     pointToLayer: 'handleCyclonePoints',
        //     layeroptions_protocol: 'WFS',
        //     legendName: 'Cyclone Point',
        //     hasLegend:true,
        //     restrictFitBounds: true
        // },
        'Segement': {
            source: 'INDIA',
            displayName: 'Segement',
            name: 'Segement',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:nhip_Segement',
            layer_name: 'nhip_Segement',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Hazard',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            crs: 'EPSG4326',
        },

    }
}

export const EQ_ZONE_COLOR: any = {
    1: '#FCB3B7', // Zone 2 (User mapping: Zone 2 - FCB3B7)
    2: '#FCB3B7',
    3: '#BAFCB6', // Zone 3 - BAFCB6
    4: '#FFFF73', // Zone 4 - FFFF73
    5: '#FFAA00', // Zone 5 - FFAA00
    6: '#E60000'  // Zone 6 - E60000
}

export const NHIP_LEGENDS: any = {
    'Magnitude': {
        Units: 'Earthquake Magnitude',
        colorValues: [
            { text: '2.50 - 4.50', backgroundColor: '#FFFF73', textColor: '#000000' },
            { text: '4.51 - 6.50', backgroundColor: '#FFAA00', textColor: '#000000' },
            { text: '6.51 - 9.00', backgroundColor: '#FF0000', textColor: '#000000' }
        ]
    },
    'Fault Lines': {
        Units: 'Fault Lines',
        colorValues: [
            { text: 'Fault Lines', backgroundColor: '#800000', textColor: '#fff' }
        ]
    },
    'Zones': {
        Units: 'Earthquake Zone',
        colorValues: [
            { text: 'Zone II', backgroundColor: '#FCB3B7', textColor: '#000000' },
            { text: 'Zone III', backgroundColor: '#BAFCB6', textColor: '#000000' },
            { text: 'Zone IV', backgroundColor: '#FFFF73', textColor: '#000000' },
            { text: 'Zone V', backgroundColor: '#FFAA00', textColor: '#000000' },
            { text: 'Zone VI', backgroundColor: '#E60000', textColor: '#000000' }
        ]
    },
    'Wind Zone': {
        Units: 'Wind Zone',
        colorValues: [
            { text: 'Zone 1', backgroundColor: '#B8FAFC', textColor: '#000000' },
            { text: 'Zone 2', backgroundColor: '#65f768', textColor: '#000000' },
            { text: 'Zone 3', backgroundColor: '#ffff00', textColor: '#000000' },
            { text: 'Zone 4', backgroundColor: '#fa8907', textColor: '#000000' },
            { text: 'Zone 5', backgroundColor: '#ff0000', textColor: '#000000' },
            { text: 'Zone 6', backgroundColor: '#991407', textColor: '#000000' }
        ]
    },
    'Cyclone Point': {
        Units: 'Cyclone Point',
        colorValues: [
            { text: 'SUCS', backgroundColor: '#B71C1C', textColor: '#000000' },
            { text: 'ESCS', backgroundColor: '#E53935', textColor: '#000000' },
            { text: 'VSCS', backgroundColor: '#FF7043', textColor: '#000000' },
            { text: 'SCS', backgroundColor: '#FFA726', textColor: '#000000' },
            { text: 'CS', backgroundColor: '#1E88E5', textColor: '#000000' },
            { text: 'DD', backgroundColor: '#26C6DA', textColor: '#000000' },
            { text: 'D', backgroundColor: '#66BB6A', textColor: '#000000' },
            { text: 'L', backgroundColor: '#FFFFFF', textColor: '#000000' },
        ]
    },
    'Cyclone Line': {
        Units: 'Cyclone Line',
        colorValues: [
            { text: 'Cyclone Line', backgroundColor: '#003BB0', textColor: '#fff' }
        ]
    }
}

/** Legend entry text (upper-cased) -> colour, so map features are coloured exactly as their legend shows */
export function legendColorMap(legendName: string): { [text: string]: string } {
    const colors: { [text: string]: string } = {};
    NHIP_LEGENDS[legendName].colorValues.forEach((item: any) => colors[item.text.toUpperCase()] = item.backgroundColor);
    return colors;
}

/** Legend entries like '2.50 - 4.50' -> numeric bands, so features are coloured by the legend's own ranges */
export function legendRangeColors(legendName: string): { min: number; max: number; color: string }[] {
    return NHIP_LEGENDS[legendName].colorValues
        .map((item: any) => {
            const [min, max] = item.text.split('-').map((value: string) => parseFloat(value));
            return { min, max, color: item.backgroundColor };
        })
        .sort((a: any, b: any) => a.min - b.min);
}

export const CYCLONE_GRADE_COLORS = legendColorMap('Cyclone Point');

export const EQ_MAGNITUDE_BANDS = legendRangeColors('Magnitude');

export const CYCLONE_INTENSITY_MAPPING: any = {
    CS: 'Cyclonic Storm',
    SCS: 'Severe Cyclonic Storm',
    VSCS: 'Very Severe Cyclonic Storm',
    ESCS: 'Extremely Severe Cyclonic Storm',
    SuCS: 'Super Cyclonic Storm',
    DD: 'Deep depression',
    D: 'Depression',
    L: 'Low pressure'
}

export const CYCLONE_GRADE_INTENSITY_MAPPING: any = {
    'Cyclonic Storm': 'CS',
    'Severe Cyclonic Storm': 'SCS',
    'Very Severe Cyclonic Storm': 'VSCS',
    'Extremely Severe Cyclonic Storm': 'ESCS',
    'Super Cyclonic Storm': 'SuCS',
    'Deep depression': 'DD',
    'Depression': 'D',
    'Low pressure': 'L'
}







export const EarthquakeColumnConfig = {
    tableInfo: {
        type: 'dataTable',
        title: {
            display: true,
            text: '',
            align: 'center',
            order: 'order-md-2'
        },
    },
    css: {
        tableClass: 'table table-striped table-bordered m-0',
        theadClass: '',
        tbodyClass: ''
    },
    sortOptions: {
        sortIndex: -1,
        sortType: 'asc'
    },
    searchFilter: {
        display: true,
        align: 'left', // where to align the element within div i.e left, center or right
        order: 'order-md-1' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    breadcrumbCons: {
        show: true,
        queryparams: []
    },
    downloadButton: {

        display: true,
        text: 'Download',
        align: 'right', // where to align the element within div i.e left, center or right
        order: 'order-md-3' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    downloadOptions: [
        {
            downloadType: 'xlsx',
            downloadFileName: 'Disaster Monitoing',
            downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
            metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        },
        {
            downloadType: 'pdf',
            downloadFileName: 'Disaster Monitoing',
            downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
            metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        },
        {
            downloadType: 'csv',
            downloadFileName: 'Disaster Monitoing',
            downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
            metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        }
    ],
    printButton: {
        display: true,
        text: 'Print',
        align: 'right',       //where to align the element within div i.e left, center or right
        order: 'order-md-2',   //Order of the element from left. defined in DataTableModule.toolBarElementOrder
        title: 'Sites'
    },
    paginatorOptions: {
        visible: true,
        limit: 10,
        maxSize: 10,
        directionLinks: 'true',
        autoHide: 'true',
        previousLabel: 'previous',
        nextLabel: 'next',
        dropdownOptions: [{
            value: 5,
            display: '5'
        },
        {
            value: 10,
            display: '10'
        },
        {
            value: 15,
            display: '15'
        },
        {
            value: 20,
            display: '20'
        },
        {
            value: 25,
            display: '25'
        },
        {
            value: -1,
            display: 'All'
        }
        ]
    },
    tableHeaderFixerInfo: {
        headerFix: false,
        colFix: false,
        rowFix: false
    },
    indexCons: {
        show: true,
        class: 'tc-bg-01',
        tooltip: 'S.No'
    },
    columns: [
        {
            name: 'Magnitude',
            jsonKey: {
                path: 'type'
            },
            class: 'text-center',
            copyToRows: true,
            dataType: 'TEXT',
            defaultValue: '-'
        },
        {
            name: 'Depth (km)',
            jsonKey: {
                path: 'depth'
            },
            class: 'tc-bg-01 text-center',
            copyToRows: true,
            dataType: 'NUMBER',
            defaultValue: '-'
        },
        {
            name: 'Location',
            jsonKey: {
                path: 'place'
            },
            class: 'tc-bg-01 text-center',
            copyToRows: true,
            dataType: 'TEXT',
            defaultValue: '-'
        },
        {
            name: 'Date',
            jsonKey: {
                path: 'date'
            },
            class: 'tc-bg-01',
            dataType: 'TEXT',
            defaultValue: '-'
        }
    ]
}

export const CycloneColumnConfig = {
    tableInfo: {
        type: 'dataTable',
        title: {
            display: true,
            text: '',
            align: 'center',
            order: 'order-md-2'
        },
    },
    css: {
        tableClass: 'table table-striped table-bordered m-0',
        theadClass: '',
        tbodyClass: ''
    },
    sortOptions: {
        sortIndex: -1,
        sortType: 'asc'
    },
    searchFilter: {
        display: true,
        align: 'left', // where to align the element within div i.e left, center or right
        order: 'order-md-1' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    breadcrumbCons: {
        show: true,
        queryparams: []
    },
    downloadButton: {

        display: true,
        text: 'Download',
        align: 'right', // where to align the element within div i.e left, center or right
        order: 'order-md-3' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    downloadOptions: [
        {
            downloadType: 'xlsx',
            downloadFileName: 'Disaster Monitoing',
            downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
            metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        },
        {
            downloadType: 'pdf',
            downloadFileName: 'Disaster Monitoing',
            downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
            metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        },
        {
            downloadType: 'csv',
            downloadFileName: 'Disaster Monitoing',
            downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
            metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        }
    ],
    printButton: {
        display: true,
        text: 'Print',
        align: 'right',       //where to align the element within div i.e left, center or right
        order: 'order-md-2',   //Order of the element from left. defined in DataTableModule.toolBarElementOrder
        title: 'Sites'
    },
    paginatorOptions: {
        visible: true,
        limit: 10,
        maxSize: 10,
        directionLinks: 'true',
        autoHide: 'true',
        previousLabel: 'previous',
        nextLabel: 'next',
        dropdownOptions: [{
            value: 5,
            display: '5'
        },
        {
            value: 10,
            display: '10'
        },
        {
            value: 15,
            display: '15'
        },
        {
            value: 20,
            display: '20'
        },
        {
            value: 25,
            display: '25'
        },
        {
            value: -1,
            display: 'All'
        }
        ]
    },
    tableHeaderFixerInfo: {
        headerFix: false,
        colFix: false,
        rowFix: false
    },
    indexCons: {
        show: true,
        class: 'tc-bg-01',
        tooltip: 'S.No'
    },
    columns: [
        {
            name: 'Name',
            jsonKey: {
                path: 'hazardName'
            },
            class: 'tc-bg-01 text-center',
            copyToRows: true,
            dataType: 'HTML',
            defaultValue: '-'
        },
        {
            name: 'Intensity',
            jsonKey: {
                path: 'intensity'
            },
            class: 'tc-bg-01 text-center',
            copyToRows: true,
            dataType: 'HTML',
            defaultValue: '-'
        },
        {
            name: 'Basin',
            jsonKey: {
                path: 'basin'
            },
            class: 'tc-bg-01 text-center',
            copyToRows: true,
            dataType: 'RAW_TEXT',
            defaultValue: '-'
        },
        {
            name: 'Description',
            jsonKey: {
                path: 'description'
            },
            class: 'tc-bg-01 text-center',
            copyToRows: true,
            dataType: 'TEXT',
            defaultValue: '-'
        },
        {
            name: 'Date',
            jsonKey: {
                path: 'date'
            },
            class: 'tc-bg-01 text-center',
            copyToRows: true,
            dataType: 'TEXT',
            defaultValue: '-'
        }
    ]
}

export const IndiaStateCodes: any = {
    "ANDHRA PRADESH": "AP",
    "ARUNACHAL PRADESH": "AR",
    "ASSAM": "AS",
    "BIHAR": "BR",
    "CHHATTISGARH": "CG",
    "GOA": "GA",
    "GUJARAT": "GJ",
    "HARYANA": "HR",
    "HIMACHAL PRADESH": "HP",
    "JHARKHAND": "JH",
    "KARNATAKA": "KA",
    "KERALA": "KL",
    "MADHYA PRADESH": "MP",
    "MAHARASHTRA": "MH",
    "MANIPUR": "MN",
    "MEGHALAYA": "ML",
    "MIZORAM": "MZ",
    "NAGALAND": "NL",
    "ODISHA": "OD",
    "PUNJAB": "PB",
    "RAJASTHAN": "RJ",
    "SIKKIM": "SK",
    "TAMIL NADU": "TN",
    "TELANGANA": "TS",
    "TRIPURA": "TR",
    "UTTAR PRADESH": "UP",
    "UTTARAKHAND": "UK",
    "WEST BENGAL": "WB",
    "ANDAMAN AND NICOBAR ISLANDS": "AN",
    "CHANDIGARH": "CH",
    "DADRA AND NAGAR HAVELI AND DAMAN AND DIU": "DN",
    "DELHI": "DL",
    "JAMMU AND KASHMIR": "JK",
    "LADAKH": "LA",
    "LAKSHADWEEP": "LD",
    "PUDUCHERRY": "PY"
};

export const MAP_OPTIONS: any = {
    minZoom: 4.50,
    maxZoom: 20,
    zoomSnap: 0.25,
    zoom: LOCATIONS_ZOOM[AgricultureMapConstants.LOCATIONS.KARUNGADU],
    center: LOCATIONS_LATLNG[AgricultureMapConstants.LOCATIONS.KARUNGADU],
    zoomControl: false,
    zoomAnimation: true,
    attributionControl: false
};
